import {Component, forwardRef, Injector, Input, Type} from "@angular/core";
import {ColumnComponent} from "../../../grid/column.component";
import {FUIStackedPageService} from "@fedeltapointofsale/ui";
import {AbstractColumnComponent} from "../../../grid/abstract-column.component";
import {RoutingDiscoveryService} from "../../../../../routing-discovery.service";
import {SearchPageService} from "../../search-page/search-page.service";

/**
 * Open link action
 *
 * Open a link
 */
@Component({
    selector: "wbo-open-link-column",
    templateUrl: "./open-link-column.component.html",
    styleUrls: ["./open-link-column.component.scss"],
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => OpenLinkColumnComponent), multi: true}
    ]
})
export class OpenLinkColumnComponent extends AbstractColumnComponent {

    @Input() linkPath: string;
    @Input() linkPathResolver:  (dataItem: any) => string;
    @Input() linkComponent: Type<any>;

    @Input() parameterResolver: (dataItem: any) => any;

    constructor(injector: Injector,
                private searchPageService: SearchPageService,
                private stackedPageService: FUIStackedPageService,
                private routingDiscoveryService: RoutingDiscoveryService) {
        super(injector);
    }

    /**
     * Invoked when the link is clicked
     * @param dataItem - row data
     */
    fireOpenEvent(dataItem: any) {
        let component: Type<any>;

        if (this.linkPathResolver) {
            component = this.routingDiscoveryService.findRoutingComponent(this.linkPathResolver(dataItem));
        } else if (this.linkPath) {
            component = this.routingDiscoveryService.findRoutingComponent(this.linkPath);
        } else {
            component = this.linkComponent;
        }

        const params: any = this.parameterResolver(dataItem);
        this.stackedPageService.open(component, params).subscribe(() => {
        }, () => {
        }, () => {
            this.searchPageService.requestRefresh();
        });
    }
}
